/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NurseAttribute from './nurse-attribute';
import NurseAttributeDetail from './nurse-attribute-detail';
import NurseAttributeUpdate from './nurse-attribute-update';
import NurseAttributeDeleteDialog from './nurse-attribute-delete-dialog';

const NurseAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NurseAttribute />} />
    <Route path="new" element={<NurseAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<NurseAttributeDetail />} />
      <Route path="edit" element={<NurseAttributeUpdate />} />
      <Route path="delete" element={<NurseAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NurseAttributeRoutes;
